@if(!browsersniffer.isPhone()){
  <div class="trace-header flex-container container-space-between column " tabindex="-1">
    <h4 class="">{{ "trace.import-route.title" | translate }}</h4>
    <div class="list-sub-header">{{ "trace.import-route.content" | translate }}</div>
  </div>
}

<div class="trace-body column no-footer surface-container-low">
  <!--  surface-dim surface-container-high surface-variant-->
  <div class="file-upload-container fl">
    <tt-trace-uploader #fileUploader
      [accept]="allowedMimeTypes.toString()"
      [allowedExtensions]="allowedExtensions"
      [fileButtonText]="'trace.import-route.filebuttontext'"
      [extraInfoWithDropFunctionText]="'trace.import-route.extra-info-withdropfunction'"
      [loadingText]="'trace.import-route.loading'" [loadingFailedText]="'trace.import-route.loadingfailed'"
      (onImportEvent)="($event)"
      (onReadyForGpxImportEvent)="importService.importGpxFile(fileUploader.getFiles()[0])"
      >
    </tt-trace-uploader>
  </div>

  <div class="history">
    @if(ref_historyItems().length > 0){
      <div class="mat-title-medium">{{'trace.last-routes-on-device' | translate }}</div>
    }
    @for (historyItem of ref_historyItems(); track historyItem.time) {
      <mat-card appearance="outlined" [attr.id]="historyItem.dataRef" tabindex="-1" class="historyItem mt-2" [ngClass]="{'edited': !historyItem.remoteSource}" (click)="openHistoryItem('' + historyItem.dataRef, historyItem.appId ? historyItem.appId : '')">
        <button matIconButton type="button" class="close" title="Remove from list" (click)="$event.stopPropagation();deleteHistoryItem('' + historyItem.dataRef)">
          <mat-icon>close</mat-icon>
        </button>
        <mat-card-header class="pt-1 container-space-between">
          <!-- <div mat-card-avatar class=""></div> -->
          <mat-card-title>
            <!-- 'mediumDate' without time, 'medium' with time HH:mm:ss -->
            <div class="lastaccess mat-body-medium">
              {{historyItem.time | date:'mediumDate':'+0100':lang()}}&nbsp;&nbsp;&nbsp;{{historyItem.time | date:'HH:mm':'+0100'}}
            </div>
            @if(historyItem.name){
              <div class="name " [innerHTML]="historyItem.name"></div>
            }
            @if(!historyItem.name){
              <div class="name untitled" [innerHTML]="('trace.field.noname' | translate)"></div>
            }
          </mat-card-title>
          <div class="preview" [ngClass]="{'hasPreview': historyItem.thumb && historyItem.thumb.length > 0}" style="margin-top:16px">@if (historyItem.thumb && historyItem.thumb.length > 0) {
            <img src="{{historyItem.thumb}}" alt="preview" style="max-width:70px;" />
          }
        </div>
        <!-- <mat-card-subtitle></mat-card-subtitle> -->
      </mat-card-header>
      <mat-divider></mat-divider>
      <!-- <div class="preview" [ngClass]="{'hasPreview': historyItem.thumb && historyItem.thumb.length > 0}"><img *ngIf="historyItem.thumb && historyItem.thumb.length > 0" src="{{historyItem.thumb}}" alt="preview" /></div> -->
      <mat-card-content class="routeinfo">
        <div class="routeData mb-1 align-baseline">
          <a title="{{'trace.total-distance' | translate}}">
            <mat-icon fontSet="ngi" fontIcon="measure"></mat-icon>
            <!--  -->
            <span [innerHTML]="formatRouteDistance(historyItem.dist, true)"></span>
            &nbsp;&nbsp;
          </a>
          <a title="{{'trace.total-height' | translate}}" style="padding-right: 0px;padding-left:10px">
            <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
            &nbsp;<span [innerHTML]="formatRouteDistance(historyItem.upwardDist, true)"></span>
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>